import { SidebarSHComponent } from './sidebar/sidebar-sh.component';
import { Subscription } from 'rxjs';
import { Observable, timer } from 'rxjs';
import { SwitchProfileComponent } from './../profile/switch-profile/switch-profile.component';
import { CorrectionComponent } from './../correction/correction.component';
import { AppConfig } from './../app.config';
import { SurvivalHorizonService } from './../survival-horizon/survival-horizon.service';
import { EOMBucketing } from '../bucket/eom-bucketing';
import { DashboardEventService } from '../dashboard/dashboard-event.service';
import { DailyBucketing } from '../bucket/daily-bucketing';
import { BucketedBucketing } from '../bucket/bucketed-bucketing';
import { BucketingStrategy } from '../bucket/bucketing-strategy';
import { style } from '@angular/animations';
import { Component, Input, OnInit, ViewChild, Inject, forwardRef, Output, AfterViewInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { HomeComponent } from './home.component';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { UserProfile } from '@liquitics/transaction';
import { SwitchDateComponent } from '../profile/switch-date/switch-date.component';

export enum LadderViewMode {
    DATATABLE,
    CHART
}
enum LadderBucketingMode {
    SURVIVIAL_HORIZON,
    OTHER
}

@Component({
    selector: 'app-home-sidebar',
    templateUrl: './home.sidebar.component.html',
    styleUrls: ['./home.sidebar.component.scss']
})
export class HomeSideBarComponent implements OnInit, OnDestroy, AfterViewInit {
    profileFamily: string;
    profileType: string;

    isLocalTime = true;
    weekLine: string;
    dateLine: string;
    timeLine: string;
    clockToolTip: string;

    subscription: Subscription;

    @ViewChild(SidebarSHComponent, { static: true }) sidebarSHComponent: SidebarSHComponent;


    // constructor( @Inject(forwardRef(() => HomeComponent)) public app: HomeComponent,
    constructor(
        private dashboardEventService: DashboardEventService,
        private appConfig: AppConfig,
        private dialog: MatDialog) {
    }

    ngOnInit() {
        console.log('Initializing Home Sidebar');
        this.subscription = this.dashboardEventService.profileSubject.subscribe({
            next: (userProfile: UserProfile) => {
                this.profileFamily = userProfile.getProfileFamily();
                this.profileType = userProfile.getProfileType();
                this.initializeSideBar();
            }
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    ngAfterViewInit() {
        timer(0, 10000)
            .subscribe({
                next: () => {
                    const now = moment();
                    if (!this.isLocalTime) {
                        now.utcOffset(this.appConfig.getTenantInfo().utcOffset);
                    }
                    this.weekLine = now.format('ddd').toUpperCase();
                    this.dateLine = now.format('MMM DD').toUpperCase();
                    this.timeLine = now.format('hh:mm A').toUpperCase();
                    this.clockToolTip = (this.isLocalTime) ? 'Local: ' : 'Headquarters: ';
                    this.clockToolTip += this.weekLine + ' ' + this.dateLine;
                }
            });
    }

    initializeSideBar() {
        this.profileFamily = this.appConfig.activeUserProfile.getProfileFamily();
        this.profileType = this.appConfig.activeUserProfile.getProfileType();
    }
}
